import React from 'react';
import LocationList from '@/components/LocationList';

const LocationsPage: React.FC = () => {
  return <LocationList />;
};

export default LocationsPage;
